<template>
  <div v-if="user" class="mb-8">
    <h1 class="text-center text-red-800 font-medium text-xl">CONGRATULATIONS!</h1>
    <p class="text-center font-medium text-lg">YOUR ORDER IS COMPLETE</p>
  </div>
  <div class="border border-gray-500 w-full p-6 rounded-md" v-if="user">
    <p class="text-red-800 font-medium mb-2">YOUR PRODUCT RECEIPT:</p>
    <div class="flex border-b border-gray-200 justify-between font-medium">
      <p>Product</p>
      <p>Price</p>
    </div>
    <div class="flex justify-between py-3">
      <div class="text-xs">
        <p class="py-1">{{ item }}</p>
        <p class="py-1">Shipping</p>
        <p class="py-1" v-if="add === 'add'">1 year subscription</p>
      </div>
      <p>{{ amount }} $</p>
    </div>
  </div>
  <div>
    <ul class="mt-4 ml-4">
      <li class="font-medium p-1">{{user}}</li>
      <li class="p-1">{{address}}</li>
      <li class="p-1">{{email}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "success",
  data() {
    return {
      user: "",
      address: "",
      amount: "",
      currency: "",
      email: "",
      add: "",
      item: "",
    };
  },
  created() {
    this.amount = localStorage.getItem("value");
    this.currency = localStorage.getItem("currency");
    this.email = localStorage.getItem("email");
    this.user = localStorage.getItem("name");
    this.add = localStorage.getItem("add");
    this.item = localStorage.getItem("item");
    this.address = localStorage.getItem("address");
  },
};
</script>

<style scoped></style>
